import { CategoryData } from '../types/CategoryData';

export const getCategories = (scenes: any[]) => {
  const categoryNameList: CategoryData[] = [];
  scenes.forEach((scene) => {
    if (!categoryNameList.find((c) => scene.category.name === c.name)) {
      categoryNameList.push({
        id: scene.category.id,
        name: scene.categoryName,
        code: scene.category.code,
        orderIndex: scene.category.orderIndex,
      });
    }
  });
  return categoryNameList;
};

export const reOrderIndexArray = (array: any[], activeItem: any, findIndexFunc) => {
  array.sort((a, b) => a.orderIndex - b.orderIndex);
  const idx = array.findIndex(findIndexFunc);
  if (idx <= 0) {
    return array;
  }

  activeItem.orderIndex = 1;
  array.splice(idx, 1);
  array.forEach((item, i) => {
    item.orderIndex = i + 2;
  });
  array.unshift(activeItem);
  return array;
};

export const groupCategories = (categories: CategoryData[]) => {
  const groupedCategories = [];
  const groupMap = new Map<string, { [key: string]: CategoryData }>();

  for (const item of categories) {
    if (item?.categoryGroup) {
      const groupCode = item.categoryGroup.code;

      let groupObj = groupMap.get(groupCode);
      if (!groupObj) {
        groupObj = { ...item.categoryGroup, children: [] };
        groupMap.set(groupCode, groupObj);
        groupedCategories.push(groupObj);
      }

      const child = { ...item };
      delete child.categoryGroup;
      groupObj.children.push({ ...child, parentCode: groupCode });
    } else {
      groupedCategories.push(item);
    }
  }

  return groupedCategories;
};
